/* src/app/views/admin/appointment-list/appointment-list.component.css */
input#document_upload {
  display: none;
}
::ng-deep p-paginator svg {
  transform: rotate(180deg);
}
/*# sourceMappingURL=appointment-list.component.css.map */
